export default {
  group:'mdi-account-group-outline',
  trash:'mdi-trash-can-outline',
  ban:'mdi-circle-off-outline',
  undo:'mdi-undo-variant',
  close:'mdi-close',
  plus:'mdi-plus-outline',
  minus:'mdi-minus',
  thumbsup:'mdi-thumb-up',
  thumbsdown:'mdi-thumb-down',
  error:'mdi-thumb-down',
  success:'mdi-thumb-up',
  folder:'mdi-folder',
  edit:'mdi-file-edit',
  contact:'mdi-contact-mail-outline',
  send:'mdi-email-send-outline',
  checkon:'mdi-checkbox-marked',
  checkoff:'mdi-checkbox-blank-outline',
  done:'mdi-check-circle-outline',
  info:'mdi-information-outline',
  search:'mdi-magnify',
  copy:'mdi-content-copy',
  warning:'mdi-alert-octagon',
  alert: 'mdi-alert-outline',
  question:'mdi-cloud-question',
  user:'mdi-account-group-outline',
  sms: 'mdi-message-outline',
  email: 'mdi-email-outline',
  voicemail:'mdi-voicemail',
  instagram: 'mdi-instagram',
  paypal: 'mdi-paypal',
  dashboard: 'mdi-apps',
  calendar: 'mdi-calendar',
  calendarmulti: 'mdi-calendar-blank-multiple',
  clock: 'mdi-clock',
  home: 'mdi-home',
  mapmarker: 'mdi-map-marker',
  images: 'mdi-image-edit',
  history: 'mdi-history',
  cogs: 'mdi-cogs',
  pause: 'mdi-pause-circle-outline',
  upload: 'mdi-cloud-upload-outline',
  cloud: 'mdi-cloud-lock-outline',
  link: 'mdi-link',
  list: 'mdi-format-list-bulleted',
  notes: 'mdi-note-multiple-outline',
  bell :'mdi-bell-outline',
  exclamation: 'mdi-exclamation',
  arrowleft: 'mdi-arrow-left-bold-outline',
  arrowright: 'mdi-arrow-right-bold-outline',
  arrowdown: 'mdi-arrow-down-bold-outline',
  arrowup: 'mdi-arrow-up-bold-outline',
  save: 'mdi-content-save',
  savealt: 'mdi-content-save-move-outline',
  bookmark: 'mdi-bookmark',
  creditcard: 'mdi-credit-card-outline',
  sync: 'mdi-sync',
  call: 'mdi-phone-outgoing-outline',
  thought: 'mdi-thought-bubble-outline',
  adduser: 'mdi-account-plus-outline',
  ellipse: 'mdi-ellipse-outline',
  openquote: 'mdi-format-quote-open-outline',
  closequote: 'mdi-format-quote-close-outline',
  share: 'mdi-share-variant',
  dollar: 'mdi-currency-usd',
  account: 'mdi-account-circle-outline',
  form: 'mdi-beaker-outline',
  customer: 'mdi-account-heart',
  archive: 'mdi-archive-outline',
  flag: 'mdi-flag-outline',
  receipt: 'mdi-receipt',
  invoice: 'mdi-page-previous-outline',
  orders: 'mdi-card',
  storefront: 'mdi-store-outline',
  web:'mdi-web',
  profiles: 'mdi-card-account-details-star-outline',
  download: 'mdi-download'
}